import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getBannerDetails = (id) => {
  const url = API_URLS.industryDetails(id);
  return axiosClient.get(url);
};

export const getAcessoriesDetails = (id) => {
  const url = API_URLS.accessoriesDetails(id);
  return axiosClient.get(url);
};
